import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";
import moment from "moment/moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMealReport = createAsyncThunk("fetchMealReport", async ({ filters }, { rejectWithValue }) => {
	const params = new URLSearchParams({
		keyword: filters?.keyword ?? "",
		supplier_id: filters?.supplier_id ?? "",
		meal_type_id: filters?.meal_type_id ?? "",
		department_id: filters?.department_id ?? "",
		location: filters?.location_id ?? "",
		startDate: filters?.start_date ? moment(filters?.start_date?.$d).format("YYYY-MM-DD") : "",
		endDate: filters?.end_date ? moment(filters?.end_date?.$d).format("YYYY-MM-DD") : "",
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}report?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const MealReportSlice = createSlice({
	name: "MealReportSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMealReport.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMealReport.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchMealReport.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default MealReportSlice.reducer;
